import { type OrganicStatsResponseDimensionEntry } from "../../gql-generated/types";

export const isStatsListEmpty = (statsListEntries: readonly OrganicStatsResponseDimensionEntry[]): boolean => {
    return statsListEntries.every(({ statsList }) => statsList.every(({ value }) => Number.parseInt(value) === 0));
};
